import PropTypes from "prop-types";
import "./confectionery.css";
import logo from "../../assets/images/logo-viziona-white.png";

Confectionery.propTypes = {
  confectionery: PropTypes.object,
  onSelected: PropTypes.func,
  product: PropTypes.object,
};

export default function Confectionery(props) {
  const { confectionery, onSelected, product } = props;

  return (
    <div
      className="confectionery"
      key={confectionery.id}
      onClick={() => {
        if (onSelected) {
          onSelected(product, confectionery);
        }
      }}
    >
      <div className="confectionery-detail">
        {confectionery.image !== "" ? (
          <img src={confectionery.image} alt={confectionery.name} />
        ) : (
          <div className="fallback">
            <img src={logo} />
          </div>
        )}
        <h3>{confectionery.name}</h3>
      </div>
      {onSelected && <button>Agregar al carrito</button>}
    </div>
  );
}
